import * as getters from './getters';
import * as actions from './actions';

export default {
  strict: true,
  state: {
    isFetchingBookings: false,
  },
  getters,
  actions,
  mutations: {
    'bookings/set': (state, { path, value }) => {
      state[path] = value;
    },
  },
};
